import React from 'react';

import { CSSVar, RichTextEditorStyle } from './RichTextEditor.style';

interface RichTextEditorProps {
  html: string;
  isSmallText?: boolean;
  copyColor?: string;
}

export const RichTextEditor = ({
  html,
  isSmallText = false,
  copyColor = '',
}: RichTextEditorProps) => {
  return (
    <div
      css={RichTextEditorStyle}
      dangerouslySetInnerHTML={{ __html: html }}
      data-testid="RichTextEditor"
      style={{ '--color': copyColor } as CSSVar}
      data-small-text={isSmallText}
    />
  );
};
